import { Flex, Tooltip, Typography } from 'antd';
import React from 'react';

import { TeamBadge } from '@/components';
import type { GxPReportRecord, GxPSentRecipients } from '../types';

// Backend sends [] when the report hasn't been sent
const getRecipients = (
  value: GxPReportRecord['sent_recipients']
): GxPSentRecipients | null => (value && !Array.isArray(value) ? value : null);

const GxPRecipientCell: React.FC<{ record: GxPReportRecord }> = ({
  record,
}) => {
  const recipients = getRecipients(record.sent_recipients);
  const teams = Array.isArray(recipients?.teams_users)
    ? recipients.teams_users
    : [];

  // First fully-selected team is shown as a badge
  const teamBadge = teams.find((team) => team?.select_all);

  const teamUsers = teams.flatMap((team) => {
    if (team?.select_all) {
      return team === teamBadge ? [] : [team.name];
    }
    return Array.isArray(team?.users)
      ? team.users
          .filter((u) => u?.enabled !== false)
          .map((u) => u?.name || u?.email || u?.id || '')
      : [];
  });

  const additionalUsers = (
    Array.isArray(recipients?.additional) ? recipients.additional : []
  )
    .filter((obj) => obj?.enabled !== false)
    .map((obj) => obj?.label || obj?.key || '');

  const allUsers = [...teamUsers, ...additionalUsers].filter(Boolean);

  if (!teamBadge && allUsers.length === 0) {
    return <>—</>;
  }

  const extraUsers = teamBadge ? allUsers : allUsers.slice(1);

  return (
    <Flex align='center' gap={2}>
      {teamBadge ? (
        <TeamBadge
          color={teamBadge.color}
          text={teamBadge.name}
          tooltipText={teamBadge.name}
          truncateLength={17}
          className='notification-team-badge'
        />
      ) : (
        <Typography.Text ellipsis={{ tooltip: allUsers[0] }}>
          {allUsers[0]}
        </Typography.Text>
      )}
      {extraUsers.length > 0 && (
        <Tooltip classNames={{ root: 'font-12' }} title={extraUsers.join(', ')}>
          <span>{`+${extraUsers.length}`}</span>
        </Tooltip>
      )}
    </Flex>
  );
};

export default GxPRecipientCell;
